


























import { tns } from "tiny-slider/src/tiny-slider";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class OfficesSlider extends Vue {
    @Prop({ required: true }) offices!: { id: number; acf: any };

    $refs!: Vue["$refs"] & {
        slider: HTMLElement;
    };

    slider: any = null;

    private mounted() {
        if (window.outerWidth >= 1024) {
            this.initSlider();
        }
    }

    private initSlider() {
        this.$nextTick(() => {
            this.slider = tns({
                container: this.$refs.slider,
                items: 1,
                gutter: 16,
                preventScrollOnTouch: "force",
                mouseDrag: true,
                loop: false,
                controls: false,
                nav: false,
                swipeAngle: false,
                responsive: {
                    1024: {
                        items: 2,
                        gutter: 32
                    }
                }
            });
        });
    }

    private strip_tags(input:string, allowed :string) {
        allowed = (((allowed || "") + "").toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join("");
        var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
            commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
        return input.replace(commentsAndPhpTags, "").replace(tags, function($0, $1) {
            return allowed.indexOf("<" + $1.toLowerCase() + ">") > -1 ? $0 : "";
        });
    }
}
